import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import axios from "react-axios";
import dayjs from "dayjs";

import usePlaylistAddForm from "./usePlaylistAddForm";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import { getCurrentUserPlaylists, postNewPlaylist, postTrackToPlaylist } from "~/api/getCustomPlaylists";
import { getTrack } from "~/api/getTrack";

const initialFormValues = {};

const PlaylistAdd = ({ match }) => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [loadingLists, setLoadingLists] = useState(true);
  const [track, setTrack] = useState(false);
  const [playlists, setPlaylists] = useState([]);
  const [failure, setFailure] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const trackId = parseInt(match.params.trackId, 10);

  const load = async () => {
    await getCurrentUserPlaylists(axios).then((data) => {
      setPlaylists(data.data.playlists);
      setLoadingLists(false);
    });
    await getTrack(axios, trackId).then((data) => {
      const { data: trackObj = {} } = data;
      if (trackObj.id) {
        setTrack(trackObj);
        setLoading(false);
      } else {
        setFailure(true);
      }
    });
  };
  useEffect(() => {
    load();
  }, [trackId]);

  const postPlaylist = async () => {
    setLoading(true);

    const payload = {
      ...inputs,
    };

    // playlistName

    try {
      if (payload.playlistName) {
        const resp = await postNewPlaylist(axios, { trackId, playlistName: payload.playlistName });
        const {
          status,
          data: { playlistId },
        } = resp;
        history.push(`/playlist/${playlistId}`);
      } else {
        const resp = await postTrackToPlaylist(axios, { trackId, playlistId: payload.existingPlaylist });
        history.push(`/playlist/${payload.existingPlaylist}`);
      }

      setLoading(false);
    } catch (error) {
      console.log("🚀 ~ file: PlaylistAdd.js:68 ~ postPlaylist ~ error:", error);
      setSubmitError(error.response.data.error);
      setLoading(false);
      // onFailure();
    }
  };

  // Needs away to switch handlers one for each button
  const { inputs, handleInputChange, handleSelectChange, handleSubmitTitle, handleSubmitPlaylist, errors } = usePlaylistAddForm(
    initialFormValues,
    postPlaylist
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="track-page-component page-layout-topic" style={{ padding: "20px 0 80px" }}>
        <div style={{ marginBottom: "60px" }}>
          <Row>
            {loading ||
              (loadingLists && (
                <Col xs={12} sm={{ span: 8, offset: 2 }} className="track-topic-box">
                  <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
                    <Skeleton count={1} />
                  </SkeletonTheme>
                </Col>
              )) || (
                <React.Fragment>
                  <Col xs={12} className="playlist-add-page">
                    <React.Fragment>
                      {(failure && (
                        <center>
                          Sadly this track was not found... but it might be here somewhere. Try the{" "}
                          <Link to={`/search`}>search option</Link>.
                        </center>
                      )) || (
                          <React.Fragment>
                            <div>
                              <h1>Add this track to a playlist</h1>

                              <div style={{ margin: "20px 0" }}>
                                <p>Create a new playlist with this track or add it to an existing list.</p>
                              </div>
                              <div style={{ margin: "50px 0" }}>
                                <div className="playlistCard">
                                  <Card body className="center text-left">
                                    <TrackImage styles={{ float: "left", marginRight: 0 }} width={`100px`} track={track} />
                                    <span className="trackArtist">
                                      "{track.title}" by {track.artist}
                                    </span>
                                    <div className="date"> {dayjs(track.date).format("MMMM D, YYYY")}</div>
                                  </Card>
                                </div>
                              </div>

                              {errors.subject && <Alert variant="danger">{errors.subject}</Alert>}
                              {submitError && <Alert variant="danger">Error: {submitError}</Alert>}

                              <Form
                                className="totd-form totd-form-horizontal"
                                noValidate
                                onSubmit={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                <Row className="playlistAddCols">
                                  <Col md={6} xs={12} className="playlistAddCol">
                                    <h4>Add to a new Playlist</h4>
                                    <Form.Control
                                      name="playlistName"
                                      onChange={handleInputChange}
                                      value={inputs.playlistName || ""}
                                      type="text"
                                      autoComplete="off"
                                      required
                                      className="w-50"
                                      placeholder="Enter a playlist name"
                                      style={{ display: "inline-block", marginRight: 10 }}
                                    />
                                    <Button
                                      disabled={loading}
                                      className="btn-lg"
                                      variant="success"
                                      onClick={(e) => handleSubmitTitle(e)}
                                      type="button"
                                    >
                                      Add
                                    </Button>
                                    {errors.playlistName && <span className="help error">{errors.playlistName}</span>}
                                  </Col>
                                  <Col md={6} xs={12} className="playlistAddCol">
                                    <h4>Add to an existing Playlist</h4>
                                    <div>
                                      {loadingLists && <div>Loading...</div>}
                                      {!loadingLists && playlists.length !== 0 && (
                                        <Form.Group controlId="formBasicSelect">
                                          <Form.Control
                                            as="select"
                                            value={inputs.existingPlaylist || ""}
                                            onChange={(e) => handleSelectChange("existingPlaylist", parseInt(e.target.value, 10))}
                                            style={{ display: "inline-block", width: "50%", marginRight: 10, padding: "6px 2px" }}
                                          >
                                            <option value="">Select</option>
                                            {playlists.map(({ id, name }) => (
                                              <option key={id} value={id}>
                                                {name}
                                              </option>
                                            ))}
                                          </Form.Control>
                                          <Button className="btn-lg" variant="success" onClick={(e) => handleSubmitPlaylist(e)} type="button">
                                            Add
                                          </Button>
                                        </Form.Group>
                                      )}
                                      {!loadingLists && playlists.length === 0 && <div>No playlists created yet.</div>}
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </React.Fragment>
                        )}
                    </React.Fragment>
                  </Col>
                </React.Fragment>
              )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default PlaylistAdd;
